import { Icon } from "@iconify/react/dist/iconify.js";
import { useEffect, useRef, useState } from "react";
import { createPortal } from "react-dom";
import { Tooltip } from "@mui/material";
import { useTranslation } from "react-i18next";

export default function EditorFormatter() {
  const { t } = useTranslation();
  const [openMenu, setOpenMenu] = useState(false);
  const [menuPosition, setMenuPosition] = useState({ top: 0, left: 0 });
  const menuRef = useRef(null);
  const buttonRef = useRef(null);

  const MENU_OPTIONS = [
    { title: t("chatting.formatter.bold"), label: "B", command: "bold", className: "fmt-bold" },
    { title: t("chatting.formatter.italic"), label: "I", command: "italic", className: "fmt-italic" },
  ];

  const handleClick = (event) => {
    event.preventDefault();
    if (!openMenu && buttonRef.current) {
      const rect = buttonRef.current.getBoundingClientRect();
      setMenuPosition({
        top: rect.top - 8,
        left: rect.left,
      });
    }
    setOpenMenu((prev) => !prev);
  };

  const handleClickOutside = (event) => {
    if (menuRef.current && !menuRef.current.contains(event.target) &&
        buttonRef.current && !buttonRef.current.contains(event.target)) {
      setOpenMenu(false);
    }
  };

  useEffect(() => {
    if (openMenu) {
      document.addEventListener("mousedown", handleClickOutside);
    } else {
      document.removeEventListener("mousedown", handleClickOutside);
    }
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [openMenu]);

  const menuContent = openMenu && (
    <div
      ref={menuRef}
      className="editor-formatters editor-formatters-portal"
      role="menu"
      style={{
        position: "fixed",
        top: menuPosition.top,
        left: menuPosition.left,
        transform: "translateY(-100%)",
      }}
    >
      {MENU_OPTIONS.map((item, index) => (
        <Tooltip key={index} title={item.title} placement="top">
          <button
            type="button"
            className={`editor-formatter-item-btn ${item.className}`}
            onClick={(e) => {
              e.preventDefault();
              document.execCommand(item.command);
            }}
            role="menuitem"
          >
            {item.label}
          </button>
        </Tooltip>
      ))}
    </div>
  );

  return (
    <div className="formatters-box">
      <Tooltip title={t("chatting.formatter.open")} placement="top">
        <button
          ref={buttonRef}
          type="button"
          onClick={handleClick}
          className={`open-formatter-button p-0 ${openMenu ? "formatter-active" : ""}`}
          aria-expanded={openMenu}
        >
          <Icon icon="mdi:format-text-variant" className="formatter-trigger-icon" />
        </button>
      </Tooltip>
      {createPortal(menuContent, document.body)}
    </div>
  );
}
